export enum ProductsAcronymsEnum {
    FGTS = 'fgts',
    CP = 'cp',
    CPAUTO = 'cpauto',
    INSS = 'inss',
    BB = 'bb',
    CREDCESTA = 'credcesta',
    CPENERGIA = 'cpenergia',
    IN100 = 'in100',
    CCLT = 'cclt',
}